import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./popupManager.css";
import { IoMdClose } from "react-icons/io";

const hallRoutes = [
  "/",
  "/o-nama",
  "/meni",
  "/sale",
  "/rezervacije",
  "/galerija",
  "/kontakt",
  "/mladenci",
];

// Normalize paths properly
const normalizePath = (p) => {
  const normalized = decodeURI(p)
    .toLowerCase()
    .split("?")[0]
    .replace(/\/$/, "");
  return normalized || "/";
};

export default function PopupManager() {
  const location = useLocation();

  const [showPopup1, setShowPopup1] = useState(false);
  const [animatePopup1, setAnimatePopup1] = useState(false);

  const [showPopup2, setShowPopup2] = useState(false);
  const [animatePopup2, setAnimatePopup2] = useState(false);

  const [routeReady, setRouteReady] = useState(false);

  const popup1Ref = useRef(null);
  const popup2Ref = useRef(null);

  useEffect(() => {
    const delay = setTimeout(() => setRouteReady(true), 50);
    return () => clearTimeout(delay);
  }, []);

  const openPopup1 = () => {
    setShowPopup1(true);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimatePopup1(true));
    });
  };

  const closePopup1 = () => {
    setAnimatePopup1(false);
    setTimeout(() => setShowPopup1(false), 400);
  };

  const openPopup2 = () => {
    setShowPopup2(true);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimatePopup2(true));
    });
  };

  const closePopup2 = () => {
    setAnimatePopup2(false);
    setTimeout(() => setShowPopup2(false), 400);
  };

  useEffect(() => {
    if (!routeReady) return;

    const popupShown = sessionStorage.getItem("popupShown_global");

    // Already shown → do nothing
    if (popupShown) return;

    const path = normalizePath(location.pathname);
    const normalizedRoutes = hallRoutes.map(normalizePath);

    // Optional: keep this if you ONLY want it on specific routes
    if (!normalizedRoutes.includes(path)) return;

    const timer1 = setTimeout(() => {
      openPopup1();
    }, 5000);

    const timer2 = setTimeout(() => {
      openPopup2();
      sessionStorage.setItem("popupShown_global", "true");
    }, 8000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [routeReady]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsidePopup1 =
        popup1Ref.current && !popup1Ref.current.contains(event.target);
      const clickedOutsidePopup2 =
        popup2Ref.current && !popup2Ref.current.contains(event.target);

      if (showPopup1 && clickedOutsidePopup1 && clickedOutsidePopup2) {
        closePopup1();
      }

      if (showPopup2 && clickedOutsidePopup2 && clickedOutsidePopup1) {
        closePopup2();
      }
    };

    if (showPopup1 || showPopup2) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup1, showPopup2]);

  return (
    <>
      {showPopup1 && (
        <div
          className={`popup ${animatePopup1 ? "popup-enter" : "popup-exit"}`}
          ref={popup1Ref}
        >
          <img
            src="/leaves.png"
            alt="Decorative leaves"
            className="popup-leaves"
          />
          <div className="popup-content">
            <span>
              za mesec januar, <br />
              februar i mart 2026 <br />
              godine
            </span>
            <h2>-10% popusta</h2>
            <span>na sve menije</span>
            <img src="/popupLogo.png" alt="Popup Logo" className="popup-logo" />
          </div>
          <button onClick={closePopup1}>
            <IoMdClose />
          </button>
        </div>
      )}

      {showPopup2 && (
        <div
          className={`popup ${animatePopup2 ? "popup-enter" : "popup-exit"}`}
          ref={popup2Ref}
        >
          <img
            src="/leaves.png"
            alt="Decorative leaves"
            className="popup-leaves"
          />
          <div className="popup-content">
            <h2>
              15% popusta <br />
              na radne dane <br />
              za proslave <br />
              preko 100 gostiju
            </h2>
            <img src="/popupLogo.png" alt="Popup Logo" className="popup-logo" />
          </div>
          <button onClick={closePopup2}>
            <IoMdClose />
          </button>
        </div>
      )}
    </>
  );
}
